import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { RouterStoreModule } from './router';

// API client settings
import { ApiClientSettingStoreModule } from './api-client-setting';
import { CategoryApiClientSettingStoreModule } from './category-api-client-setting';

// Levels
import { FloorStoreModule } from './floor';

// Security
import { GroupStoreModule } from './group';
import { GroupsOfGroupStoreModule } from './groups-of-group';
import { MemberGroupStoreModule } from './member-group';
import { MemberUserStoreModule } from './member-user';
import { SuggestedUserStoreModule } from './suggested-user';
import { UserStoreModule } from './user';
import { UserGroupStoreModule } from './user-group';

// Acl
import { FloorAclStoreModule } from './floor-acl/floor-acl-store.module';
import { LocationAclStoreModule } from './location-acl/location-acl-store.module';
import { RoomAclStoreModule } from './room-acl/room-acl-store.module';
import { UserGroupAclStoreModule } from './user-group-acl/user-group-acl-store.module';

// Integrated IReckon
import { IntegratedIReckonHotelStoreModule } from './integrated-ireckon-hotel';
import { IntegratedIReckonRoomStoreModule } from './integrated-ireckon-room';

// In-Room Credentials
import { CategoryInRoomCredentialsStoreModule } from './category-in-room-credentials';
import { InRoomCredentialsStoreModule } from './in-room-credentials';

// Wifi Profiles
// TODO, rename
import { WifiProfilestoreModule } from './wifi-profile';

import { CategoryAppLockStoreModule } from './category-app-lock/category-app-lock-store.module';

// Restriction Profiles
import { RestrictionsProfileStoreModule } from './restrictions-profile';

// Airplay Security
import { AirplaySecurityProfilestoreModule } from './airplay-security';
import { CategoryAirplaySecurityProfileStoreModule } from './category-airplay-security-profile';

// Apps
import { AppleApplicationStoreModule } from './apple-applications';
import { InstalledApplicationsStoreModule } from './installed-applications';

// Rollouts
import { AutomatedRolloutsStoreModule } from './automated-rollouts/automated-rollouts-store.module';

// Other
import { AppleDeviceStoreModule } from './apple-device-store';
import { AppleProfilesStoreModule } from './apple-profiles-store';
import { DeviceLocationStoreModule } from '../devices/sub-features/device-geo-location/device-location-store';
import { DeviceScheduledTasksStoreModule } from '../devices/sub-features/device-sync/device-scheduled-tasks-store';
import { DeviceSyncStatusesStoreModule } from '../devices/sub-features/device-sync/device-sync-statuses-store';
import { DevicesOsUpdateStatusesStoreModule } from '../devices/sub-features/device-os-updates/devices-os-update-statuses-store';
import { DeviceStoreModule } from './device-store';
import { MdmDeviceStoreModule } from './mdm-devices';
import { PairingStoreModule } from '../devices/sub-features/device-pairing/pairing-store';
import { DeviceApplicationStateStoreModule } from './device-application-state/device-application-state-store.module';

import { CategoryStoreModule } from './category';
import { CategoryApplicationsStoreModule } from './category-applications';
import { CategoryVppApplicationsStoreModule } from './category-vpp-applications';
import { CategoryWifiProfileStoreModule } from './category-wifi-profile-configuration';

import { ApplicationConfigurationStoreModule } from './application-configuration';
import { AvailableLookupOsUpdateStoreModule } from './available-lookup-os-update';
import { CertificateStoreModule } from './certificate';
import { ConfigurationProfileStoreModule } from './configuration-profile';
import { DeviceInformationStoreModule } from './device-information-store';
import { MdmAvailableOsUpdatesStoreModule } from './mdm-available-os-updates';
import { MdmInstalledApplicationsStoreModule } from './mdm-installed-applications';
import { SecurityInfoStoreModule } from './security-info';

// Resolvers
import { AllowedOsUpdatesStoreModule } from '../devices/sub-features/device-os-updates/device-allowed-os-updates-store';
import { CategoryAppSettingsStoreModule } from './app-settings';
import { AvailableOsUpdatesStoreModule } from './available-os-updates';
import { CategoryRestrictionProfileConfigurationModule } from './category-restriction-profile-configuration';
import { CommandContentStoreModule } from './command-content';
import { CommandProgressStoreModule } from './command-progress';
import { DeviceAssignmentHistoryStoreModule } from '../devices/sub-features/device-assignment/assignment-history/device-assignment-history-store';
import { DeviceConfiguredApplicationsStoreModule } from '../devices/sub-features/applications-on-device/device-configured-applications-store';
import { DeviceInstalledApplicationsStoreModule } from '../devices/sub-features/applications-on-device/device-installed-applications-store';
import { DeviceActiveSyncsStoreModule } from '../devices/sub-features/device-sync/device-active-syncs-store';
import { LocationAllowedOsUpdateStoreModule } from './location-allowed-os-updates';
import { ManagementTokensStoreModule } from './management-store/management-store.module';
import { NotesStoreModule } from '../devices/sub-features/device-notes/notes-store';
import { OsUpdateStatesStoreModule } from './os-update-state/os-update-states-store.module';
import { ApplicationConfigurationResolver } from './resolvers/application-configuration.resolver';
import { AvailableLookupOsUpdateResolver } from './resolvers/available-lookup-os-update.resolver';
import { AvailableOsUpdatesResolver } from './resolvers/available-osupdates.resolver';
import { CertificateResolver } from './resolvers/certificate.resolver';
import { CommandProgressResolver } from './resolvers/command-progress.resolver';
import { ConfigurationProfileResolver } from './resolvers/configuration-profile.resolver';
import { DeviceInformationResolver } from './resolvers/device-information.resolver';
import { FloorResolver } from './resolvers/floor.resolver';
import { GroupsOfGroupResolver } from './resolvers/groups-of-group.resolver';
import { LocationAllowedOsUpdateResolver } from './resolvers/location-allowed-os-updates.resolver';
import { ManagementResolver } from './resolvers/management.resolver';
import { MdmAvailableOsUpdatesResolver } from './resolvers/mdm-available-os-updates.resolver';
import { MdmInstalledApplicationsResolver } from './resolvers/mdm-installed-applications.resolver';
import { OsUpdateStatesResolver } from './resolvers/os-update-states.resolver';
import { SecurityInfoResolver } from './resolvers/security-info.resolver';
import { UnenrolledDeviceResolver } from './resolvers/unenrolled-device.resolver';
import { UserGroupResolver } from './resolvers/user-group.resolver';
import { VppApplicationsResolver } from './resolvers/vpp-applications.resolver';
import { ScheduledApplicationsStoreModule } from './scheduled-applications/scheduled-applications-store.module';
import { UnenrolledDeviceStoreModule } from './unenrolled-device/unenrolled-device-store.module';
import { VppApplicationsStoreModule } from './vpp-applications';

@NgModule({
  imports: [
    CommonModule,
    RouterStoreModule,
    CategoryStoreModule,
    GroupStoreModule,
    UserStoreModule,
    UserGroupStoreModule,
    MemberUserStoreModule,
    MemberGroupStoreModule,
    SuggestedUserStoreModule,
    FloorStoreModule,
    ApiClientSettingStoreModule,
    CategoryApiClientSettingStoreModule,
    IntegratedIReckonHotelStoreModule,
    IntegratedIReckonRoomStoreModule,
    InRoomCredentialsStoreModule,
    CategoryInRoomCredentialsStoreModule,
    AirplaySecurityProfilestoreModule,
    DeviceStoreModule,
    AppleDeviceStoreModule,
    WifiProfilestoreModule,
    PairingStoreModule,
    DeviceSyncStatusesStoreModule,
    DevicesOsUpdateStatusesStoreModule,
    DeviceScheduledTasksStoreModule,
    DeviceActiveSyncsStoreModule,
    AppleProfilesStoreModule,
    CategoryAppLockStoreModule,
    RestrictionsProfileStoreModule,
    InstalledApplicationsStoreModule,
    LocationAclStoreModule,
    FloorAclStoreModule,
    RoomAclStoreModule,
    UserGroupAclStoreModule,
    GroupsOfGroupStoreModule,
    VppApplicationsStoreModule,
    CategoryAirplaySecurityProfileStoreModule,
    CategoryApplicationsStoreModule,
    CategoryRestrictionProfileConfigurationModule,
    CategoryVppApplicationsStoreModule,
    CategoryWifiProfileStoreModule,
    AllowedOsUpdatesStoreModule,
    AppleApplicationStoreModule,
    AutomatedRolloutsStoreModule,
    LocationAllowedOsUpdateStoreModule,
    CommandProgressStoreModule,
    CommandContentStoreModule,
    UnenrolledDeviceStoreModule,
    OsUpdateStatesStoreModule,
    ManagementTokensStoreModule,
    AvailableOsUpdatesStoreModule,
    NotesStoreModule,
    MdmDeviceStoreModule,
    ScheduledApplicationsStoreModule,
    SecurityInfoStoreModule,
    DeviceLocationStoreModule,
    ApplicationConfigurationStoreModule,
    CertificateStoreModule,
    ConfigurationProfileStoreModule,
    MdmInstalledApplicationsStoreModule,
    AvailableLookupOsUpdateStoreModule,
    MdmAvailableOsUpdatesStoreModule,
    DeviceInformationStoreModule,
    DeviceInstalledApplicationsStoreModule,
    DeviceConfiguredApplicationsStoreModule,
    DeviceAssignmentHistoryStoreModule,
    CategoryAppSettingsStoreModule,
    DeviceApplicationStateStoreModule,
  ],
  declarations: [],
})
export class EraStoresModule {
  static forRoot(): ModuleWithProviders<EraStoresModule> {
    return {
      ngModule: EraStoresModule,
      providers: [
        FloorResolver,
        VppApplicationsResolver,
        GroupsOfGroupResolver,
        UserGroupResolver,
        OsUpdateStatesResolver,
        LocationAllowedOsUpdateResolver,
        CommandProgressResolver,
        UnenrolledDeviceResolver,
        ManagementResolver,
        AvailableOsUpdatesResolver,
        SecurityInfoResolver,
        SecurityInfoResolver,
        ApplicationConfigurationResolver,
        CertificateResolver,
        ConfigurationProfileResolver,
        MdmInstalledApplicationsResolver,
        AvailableLookupOsUpdateResolver,
        MdmAvailableOsUpdatesResolver,
        DeviceInformationResolver,
      ],
    };
  }
}
